const { App } = require("./components/App");

const app = new App();